import { Link } from 'react-router-dom';

/**
 * Site-wide copyright + legal disclaimer. Rendered at the bottom of every
 * page surface (Landing, Auth, ForgotPassword, Onboarding, and the
 * authenticated Layout that wraps all /app/* routes).
 */
export default function LegalFooter({ className = '' }) {
    return (
        <footer
            className={`relative z-10 text-forest-soft text-xs w-full px-6 pt-10 pb-8 space-y-3 ${className}`}
            data-testid="legal-footer"
        >
            <p className="text-left flex flex-wrap items-center gap-x-4 gap-y-1" data-testid="legal-copyright">
                <span>© {new Date().getFullYear()} Quiet Mind, Dr Brandt Gibson, LLC &amp; Dr Brandt R Gibson. All Rights Reserved</span>
                <span className="opacity-60">·</span>
                <Link to="/terms" data-testid="footer-terms-link" className="underline hover:text-forest">Terms</Link>
                <Link to="/privacy" data-testid="footer-privacy-link" className="underline hover:text-forest">Privacy</Link>
            </p>
            <p className="text-center leading-relaxed max-w-3xl mx-auto" data-testid="legal-disclaimer">
                By utilizing this tool, you agree to all of the following: You understand this to be an expression of opinions and not professional, medical or legal advice. You are solely responsible for the use of any content and hold Quiet Mind, Dr Brandt Gibson LLC, Dr Brandt Gibson and all members and affiliates harmless in any event or claim. If you have any concerns or questions about the advice given, it is recommended you discuss with a qualified business lawyer.
            </p>
            <p className="text-center leading-relaxed max-w-3xl mx-auto" data-testid="legal-affiliate">
                If you purchase anything through a link in this tool, you should assume that we have an affiliate relationship with the company providing the product or service that you purchase, and that we will be paid in some way. We recommend that you do your own independent research before purchasing anything.
            </p>
        </footer>
    );
}
